<template>
  <div>
    <Card>
      <Form ref="warehouse"
            :model="warehouse"
            :label-width="120">
        <Form-item :label="$t('pages_warehouses_new_1146')"
                   prop="booking">
          <Select v-model="warehouse.fresh_booking_id"
                  :placeholder="$t('pages_warehouses_new_1146')"
                  clearable
                  @on-change="fetch_booking_products">
            <Option v-for="(cat, index) in bookings"
                    :value="cat.id"
                    :key="index">{{ cat.code }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_warehouses_index_1143')"
                   prop="depot">
          <Select v-model="warehouse.fresh_depot_id"
                  clearable
                  :placeholder="$t('pages_cleaner_index_260')">
            <Option v-for="(cat, index) in depots"
                    :value="cat.id"
                    :key="index">{{ cat.name }}</Option>
          </Select>
        </Form-item>
        <Form-item v-if="booking_products.length !== 0">
          <Table border
                 :columns="columns"
                 :data="booking_products"
                 ref="table"></Table>
        </Form-item>
        <Form-item :label="$t('pages_bookings_index_230')"
                   prop="note">
          <Input type="text"
                 v-model="warehouse.note" />
        </Form-item>
        <Form-item>
          <Button type="primary"
                  long
                  @click="handleSubmit('warehouse')">{{$t('pages_warehouses_new_1147')}}</Button>
        </Form-item>
      </Form>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_bookings_detail_222'),
          key: 'product_name',
          align: 'center'
        },
        {
          title: i18n.t('pages_bookings_detail_223'),
          key: 'stocks',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_bookings_detail_224'),
          key: 'jinghuojia',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_bookings_detail_225'),
          key: 'total',
          width: 100,
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.depot_index()
    this.index({ per: 100 })
    this.booking_products_index({ id: null })
  },
  computed: {
    ...mapGetters('depot', ['depots']),
    ...mapGetters('warehouse', ['warehouse']),
    ...mapGetters('booking', ['bookings', 'booking_products'])
  },
  methods: {
    ...mapActions('warehouse', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    fetch_booking_products (booking_id) {
      this.booking_products_index({ id: booking_id })
    },
    ...mapActions('depot', { depot_index: 'index' }),
    ...mapActions('warehouse', ['index']),
    ...mapActions('booking', ['index', 'booking_products_index']),
    async handleSubmit () {
      await this.create(this.warehouse)

      this.$router.replace('/cg/warehouse')
    }
  }
}
</script>
